class AccountDelegate {
    setFirstName(firstName) {
        this.setState({ firstName });
    }

    setLastName(lastName) {
        this.setState({ lastName });
    }

    setEmail(email) {
        this.setState({ email });
    }

    setPhoneNumber(phoneNumber) {
        this.setState({ phoneNumber });
    }

    setCurrentPassword(currentPassword) {
        this.setState({ currentPassword });
    }

    setNewPassword(newPassword) {
        this.setState({ newPassword });
    }

    setConfirmPassword(confirmPassword) {
        this.setState({ confirmPassword });
    }

    setShowPasswordSection(showPasswordSection) {
        this.setState({ showPasswordSection });
    }

    handleTogglePasswordSection() {
        this.setShowPasswordSection(!this.state.showPasswordSection);
        // Clear password fields when toggling
        if (this.state.showPasswordSection) {
            this.setCurrentPassword('');
            this.setNewPassword('');
            this.setConfirmPassword('');
        }
    }
}

export default AccountDelegate;

